import { useSelector } from 'react-redux';

import PrivateRoute from 'containers/PrivateRoute';
import { canAccessMarketingCampaigns } from '../utils/marketingCampaignPermissions';

import { InitialSetupCheckProvider } from '../hooks/InitialSetupCheckContext';
import SetupCheckerWrapper from './SetupCheckerWrapper';

const MarketingGeneralRoute = ({ children }) => {
    const isAllowed = useSelector(canAccessMarketingCampaigns);

    return (
        <PrivateRoute isAllowed={isAllowed} redirectTo="/">
            <InitialSetupCheckProvider>
                <SetupCheckerWrapper>{children}</SetupCheckerWrapper>
            </InitialSetupCheckProvider>
        </PrivateRoute>
    );
};

export default MarketingGeneralRoute;
